// extracted by mini-css-extract-plugin
export var auto = "_2v-1";
export var spinner = "_2v-0";